<template>
    <open-card :open="cardOpen" class="card-cover">
        <b-input-group class="w-100 position-relative">
            <b-input-group-prepend is-text>
                <i class="fa-regular fa-calendar"></i>
            </b-input-group-prepend>
            <div class="position-absolute top left right bottom" style="z-index: 1000"
                 @click="cardOpen=!cardOpen"></div>
            <b-form-input :value="rangeStr"></b-form-input>
        </b-input-group>

        <template #card>
            <div class="d-flex flex-row">
                <b-calendar hide-header
                            :max="fromMax"
                            :date-disabled-fn="dateDisabledLeft"
                            :date-info-fn="dateClass"
                            @context="contextChange($event, 'f')"
                            @selected="dateSelected($event,'f')"></b-calendar>
                <b-calendar ref="right" hide-header
                            :min="toMin"
                            :date-disabled-fn="dateDisabledRight"
                            :date-info-fn="dateClass"
                            @context="contextChange($event, 't')"
                            @selected="dateSelected($event,'t')"></b-calendar>
            </div>
        </template>
    </open-card>
</template>

<script>
import OpenCard from "@/components/common/assistant/OpenCard.vue";
import valueMixin from "@/components/common/inputs/mixin/value-mixin";

export default {
    name: "MiniDateRange",
    components: {OpenCard},
    mixins: [valueMixin],
    props: {
        type: {
            type: String,
            default: 'datetime'
        },
        toJson: Boolean,
    },
    data() {
        return {
            from: null,
            to: null,
            fromMax: '',
            toMin: '',
            cardOpen: false,

            leftYMD: null,
            rightYMD: null,

            preSelectFlag: ''
        }
    },
    computed: {
        range() {
            return [this.from, this.to];
        },
        rangeStr() {
            return this.from + ' - ' + this.to;
        },
    },
    watch: {
        range() {
            if (this.toJson) {
                this.localValue = JSON.stringify(this.range);
            } else {
                this.localValue = this.range;
            }
        },
    },
    methods: {
        dateClass(ymd, date) {
            if (this.from && this.to) {
                let fd = new Date(this.from);
                let td = new Date(this.to);
                return this.dateDayAfter(fd, date) && date <= td ? 'table-info' : '';
            }
            return '';
        },
        dateDayAfter(before, after) {
            return after.getFullYear() > before.getFullYear()
                || after.getFullYear() === before.getFullYear() && after.getMonth() > before.getMonth()
                || after.getFullYear() === before.getFullYear() && after.getMonth() === before.getMonth() && after.getDate() >= before.getDate();
        },
        dateDisabledLeft(ymd, date) {
            return this.leftYMD && this.leftYMD.getMonth() !== date.getMonth();
        },
        dateDisabledRight(ymd, date) {
            return this.rightYMD && this.rightYMD.getMonth() !== date.getMonth();
        },
        contextChange(context, flag) {
            let target = new Date(context.activeYMD);
            this.setupActiveRange(target, flag);
        },
        setupActiveRange(target, flag) {
            switch (flag) {
                case 'f':
                    this.leftYMD = target;
                    this.toMin = new Date(target.getFullYear(), target.getMonth() + 1, 1);
                    break;
                case 't':
                    this.rightYMD = target;
                    this.fromMax = new Date(target.getFullYear(), target.getMonth(), 0);
                    if (this.leftYMD
                        && this.leftYMD.getFullYear() === this.rightYMD.getFullYear()
                        && this.leftYMD.getMonth() === this.rightYMD.getMonth()) {
                        this.$refs.right && this.$refs.right.gotoNextMonth();
                    }
                    break;
            }
        },

        dateSelected(ymd, flag) {
            if (this.preSelectFlag !== flag) {
                this.set(ymd, flag);
            } else {
                this.set(ymd, this.getObFlag(flag));
            }
        },
        getObFlag(flag) {
            return flag === 'f' ? 't' : 'f'
        },
        set(ymd, flag) {
            switch (flag) {
                case 'f':
                    this.from = ymd;
                    break;
                case 't':
                    this.to = ymd;
                    break;
            }
            this.preSelectFlag = flag;
            if (this.dateDayAfter(new Date(this.to), new Date(this.from))) {
                let temp = this.from;
                this.from = this.to;
                this.to = temp;
                this.preSelectFlag = this.getObFlag(this.preSelectFlag);
            }
        },
    }
}
</script>

<style scoped>
.card-cover {

}

.card-cover >>> .card-div {
    width: max-content !important;
    padding: .2rem;
    overflow: unset;
}

.date-input {
    width: 130px;
}
</style>
